import { uuid } from 'admin';

import { Bale } from '../types';

export const createBaleFromFile = (photo: File): Bale => ({
  id: uuid(),
  photo: photo,
});
